import React from "react";
import { Row, Col, Typography } from "antd";
import dayjs from "dayjs";
import "../FormsIp.css";

const { Text } = Typography;

const PatientProfile = ({ data }) => {
  const primaryConsultants =
    data?.primary_consultant_details?.map(
      (consultant) => consultant.primary_consultant_name
    ) || [];
  const patientData = {
    name: `${data?.patient?.first_name || ""} ${
      data?.patient?.last_name || ""
    }`.trim(),
    age: data?.patient?.age_by_dob,
    sex: data?.patient?.gender,
    contactNumber: data?.patient?.mobile,
    ipNumber: data?.ip_id,
    uidNumber: data?.patient?.patient_id,
    address: data?.patient?.address,
    dateOfAdmission: data?.admission_date
      ? dayjs(data?.admission_date).format("MMMM DD, YYYY")
      : "—",
    dateOfDischarge: data?.discharge_date
      ? dayjs(data?.discharge_date).format("MMMM DD,YYYY")
      : "Active Patient",
    primaryConsultant: primaryConsultants,
  };

  const fields = [
    { label: "Name", value: patientData.name || "—", span: { xs: 24, sm: 24, md: 12, lg: 12 } },
    { label: "Sex", value: patientData.sex },
    { label: "Contact Number", value: patientData.contactNumber },
    { label: "IP Number", value: patientData.ipNumber },
    { label: "Date of Admission", value: patientData.dateOfAdmission },
    { label: "Date of Discharge", value: patientData.dateOfDischarge },
    { label: "Age", value: patientData.age },
    { label: "Address", value: patientData.address || "—" },
    { label: "UID Number", value: patientData.uidNumber },
    {
      label: "Primary Consultant",
      value: patientData.primaryConsultant?.length
        ? patientData.primaryConsultant.join(", ")
        : "—",
    },
  ];

  return (
    <div className="forms-ip-patient-profile">
      <Row gutter={[16, 16]}>
        {fields.map((field) => (
          <Col
            xs={field.span?.xs ?? 24}
            sm={field.span?.sm ?? 12}
            md={field.span?.md ?? 8}
            lg={field.span?.lg ?? 6}
            key={field.label}
          >
            <Text className="forms-ip-patient-label">{field.label}</Text>
            <Text className="forms-ip-patient-value">{field.value}</Text>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PatientProfile;
